import React from 'react';
import PropTypes from 'prop-types';
import AImageLink from '../atoms/_atoms.image-link';

export default function MImageLinkList({ items, className }) {
	return (
		<article className={`m-image-link-list ${className}`}>
			{
				items.map(item => (<AImageLink key={item.id} {...item} />))
			}
		</article>
	);
}

MImageLinkList.propTypes = {
	items: PropTypes.array.isRequired,
	className: PropTypes.string,
};

MImageLinkList.defaultProps = {
	className: '',
};




// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.image-link-list.js